import React, { Children, isValidElement, useState, useEffect } from 'react';
import classNames from 'classnames';
import MediaQuery from 'react-responsive';

import MenuSpy from 'cityads-v3/components/MenuSpy/MenuSpy';

import ScrollToTopOnMount from 'cityads-v3/containers/misc/ScrollToTopOnMount';

import { breakpoints } from 'cityads-v3/utils/styleUtils';

import classes from './PageWithMenu.scss';

const sideMenuBreakpoint = breakpoints.lg;
const serverMediaDefaults = {
  width: breakpoints.md,
};

const HEADER_OFFSET = 16;

export default function PageWithMenu({
  children,
  menuItems: _menuItems = null,
  className = null,
  menuClassName = null,
  contentClassName = null,
  itemContainerClassName = null,
}) {
  const [offset, setOffset] = useState(null);

  const headerEl = window?.document.getElementById('header');
  const headerHeight = headerEl?.offsetHeight;

  useEffect(() => {
    setOffset(headerEl ? -headerHeight - HEADER_OFFSET : 0);
  }, [headerEl, headerHeight]);

  const menuItems = _menuItems ?? Children.map(children, child => isValidElement(child) && {
    key: child.props['data-page-menu-key'],
    icon: child.props['data-page-menu-icon'],
    title: child.props['data-page-menu-title'],
  }).filter(item => !!item && !!item.key);

  return (
    <div className={classNames(classes.page, className)}>
      <ScrollToTopOnMount />

      <div className={classNames(classes.menu, menuClassName)}>
        <MediaQuery minWidth={sideMenuBreakpoint} device={window ? null : serverMediaDefaults}>
          {(isMenuSide) => (
            <MenuSpy
              sticky = {isMenuSide}
              items  = {menuItems}
              offset = {offset}
            />
          )}
        </MediaQuery>
      </div>

      <div className={classNames(classes.content, contentClassName)}>
        {Children.map(children, child => {
          const key = isValidElement(child) ? child.props['data-page-menu-key'] : null;

          if (!key) {
            return child;
          }

          return (
            <div key={key} id={key} className={classNames(classes.itemContainer, itemContainerClassName)}>
              {child}
            </div>
          );
        })}
      </div>
    </div>
  );
}
